import {
  HrClearanceStatus, HrDepartments, HrEeoType, HrEmployeeJobAssignments, HrEmployeeStatus, HrEmploymentStatus, HrEmploymentType,
  HrFyPayRates, HrGenderType, HrJobCategoriesTable, HrJobTitles, HrMaritalStatus, HrOccStatus, HrOtherSpecialtyType, HrPscType, HrShareholderType, HrUnionAffiliation,
  HrWorkSections
} from "../../../models";


export class ClearanceStatus extends HrClearanceStatus {
  constructor() {
    super();
    this.clearanceStatusId = 0;
    this.clearanceStatus = null;
  }

}

export class Departments extends HrDepartments {
  constructor() {
    super();
    this.departmentId = 0;
    this.department = null;
    this.departmentCode = null;
    this.managerId = null;
    this.active = true;
  }

}

export class EeoType extends HrEeoType {
  constructor() {
    super();
    this.eeoId = 0;
    this.eeoType = null;
    this.eeoCode = null;
  }

}

export class EmployeeJobAssignments extends HrEmployeeJobAssignments {
  constructor() {
    super();
    this.employeeJobAssignmentId = 0;
    this.employeeJobAssignmentCode = null;
    this.assignmentDescription = null;
    this.workOrderDropDown = false;
    this.jobTitleId = null;
    this.active = true;
  }

}

export class EmployeeStatus extends HrEmployeeStatus {
  constructor() {
    super();
    this.employeeStatusId = 0;
    this.employeeStatus = null;
    this.hrAuditRequired = true;
    this.wsLeadReviewRequired = false;
    this.dmApprovalRequired = false;
    this.pmmApprovalRequired = false;
    this.hrmApprovalRequired = true;
    this.acctReceivalRequired = false;
    this.itReceivalRequired = false;
  }

}

export class EmploymentStatus extends HrEmploymentStatus {
  constructor() {
    super();
    this.employmentStatusId = 0;
    this.employmentStatusCode = null;
    this.employmentStatus = null;
  }

}

export class EmploymentType extends HrEmploymentType {
  constructor() {
    super();
    this.employmentTypeCode = null;
    this.employmentType = null;
  }

  employmentTypeId: number = 0;
}

export class FyPayRates extends HrFyPayRates {
  constructor() {
    super();
    this.fyPayRateId = 0;
    this.fiscalYear = null;
    this.payRate = null;
    this.jobTitleId = null;
    this.pmmApprovedById = null;
    this.pmmApprovedOn = null;
    this.hrmApprovedById = null;
    this.hrmApprovedOn = null
    this.pscsGenerated = false;
  }

}

export class GenderType extends HrGenderType {
  constructor() {
    super();
    this.genderTypeId = 0;
    this.genderTypeCode = null;
    this.genderType = null;
  }

}

export class JobCategoriesTable extends HrJobCategoriesTable {
  constructor() {
    super();
    this.jobCategoryId = 0;
    this.jobCategory = null;
  }

}

export class JobTitles extends HrJobTitles {
  constructor() {
    super();
    this.jobTitleId = 0;
    this.jobTitle = null;
    this.jobCategoryId = null;
    this.workSectionId = null;
    this.unionAffiliationId = null;
    this.active = true;
    this.payrollCode = null;
    this.onSeniorityList = true;
    this.color = '#ffff00';
  }

}

export class MaritalStatus extends HrMaritalStatus {
  constructor() {
    super();
    this.maritalStatusId = 0;
    this.maritalStatusCode = null;
    this.maritalStatus = null;
  }

}

export class OccStatus extends HrOccStatus {
  constructor() {
    super();
    this.occStatusId = 0;
    this.occStatus = null;
    this.sortOrder = 0;
  }

}

export class OtherSpecialtyType extends HrOtherSpecialtyType {
  constructor() {
    super();
    this.otherSpecialtyTypeId = 0;
    this.otherSpecialtyType = null;
  }

}

export class PscType extends HrPscType {
  constructor() {
    super();
    this.pscTypeId = 0;
    this.pscType = null;
    this.hrAuditRequired = true;
    this.wsLeadReviewRequired = false;
    this.dmApprovalRequired = false;
    this.pmmApprovalRequired = false;
    this.hrmApprovalRequired = true;
    this.acctReceivalRequired = false;
    this.itReceivalRequired = false;
    this.canSelfService = false;
    this.dmSelfService = false;
  }

}

export class ShareholderType extends HrShareholderType {
  constructor() {
    super();
    this.shareholderTypeId = 0;
    this.shareholderType = null;
  }

}

export class UnionAffiliation extends HrUnionAffiliation {
  constructor() {
    super();
    this.unionAffiliationId = 0;
    this.unionAffiliationCode = null;
    this.unionAffiliation = null;
  }

}

export class WorkSections extends HrWorkSections {
  constructor() {
    super();
    this.workSectionId = 0;
    this.departmentId = null;
    this.workSection = null;
    this.leadId = null;
    this.active = true;
  }

}
